import { render, staticRenderFns } from "./topLeft.vue?vue&type=template&id=736697d4&scoped=true&"
import script from "./topLeft.vue?vue&type=script&lang=js&"
export * from "./topLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736697d4",
  null
  
)

export default component.exports